import {
  toWSDateString,
  WSTableCell,
  WSTableColumn
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { getWorkLogPayerStatusPill } from "../../utils/getWorkLogPayerStatusPill";
import { TableItemData } from "./TableWorkLogsPayerView";

export const columns: WSTableColumn<TableItemData>[] = [
  {
    config: {
      header: {
        text: "Work log #"
      }
    },
    renderFunction: item => <WSTableCell text={item.data.workLogId} />
  },
  {
    config: {
      header: {
        text: "Amount"
      }
    },
    renderFunction: item => <WSTableCell text={formatMoney(0, "USD")} />
  },
  {
    config: {
      header: {
        text: "Last modified"
      }
    },
    renderFunction: item => (
      <WSTableCell text={toWSDateString(item.data.updatedAt, "timeframe")} />
    )
  },
  {
    config: {
      header: {
        text: "Status"
      }
    },
    renderFunction: item => (
      <WSTableCell pill={getWorkLogPayerStatusPill(item.data)} />
    )
  }
];
